import React from 'react';
import TextBlock from '../Components/TextBlock';
import Collaps from '../Components/Collaps';

const H2 = (props) => {
    return (
			<React.Fragment>

      	<TextBlock name='Допомога в оформлені підприємницької діяльності'>
      	  <section className="s-text">
			Вирішили відкрити свою справу, але не знаєте які КВЕД чи систему оподаткування обрати, або не маєте бажання оббивати пороги державних органів, по декілька разів вистоювати черги та ризикувати з оформленням документів? <br/>
			Ми проконсультуємо, допоможемо підібрати оптимальну форму ведення підприємницької діяльності та забезпечмо відкриття вашого бізнесу у найкоротші строки!   
      	  </section>
      	  <section className="s-textb">
            Відкриття ФОП - 1500 грн. <br/>
			До послуги входить: <br/>
            Консультація з питань оподаткування та оформлення ФОП (до 20 хвилин).<br/>
            Підбір КВЕД <br/>
            За потреби, переведення ФОП на спрощену систему оподаткування. <br/>
      	    Строк виконання 1-3 робочі дні. <br/>
			 
      	  </section>
					
					
					<section className="s-text">
						Для проведення реєстрації підприємницької діяльності можуть знадобитися:<br/>
						
							- паспортні відомості та ідентифікаційний номер; <br/>
							- електронний цифровий підпис, або застосунок "Дія", або нотаріально посвідчена довіреність на реєстрацію ФОП, або ваша присутність. <br/>
							Реєстрацію можна провести як в нашому офісі так і у зручному для вас місці або онлайн.
							
						
      	  </section>
      	</TextBlock>

				
				<TextBlock name='Окремі послуги'>
					<React.Fragment>
						
							<table>
							<tbody>
								<tr> 
									<th>Послуга</th> 
									<th>Строк виконання</th> 
									<th>Вартість</th> 
								</tr>
								<tr> 
									<td>Консультація з питань реєстрації ФОП та оподаткування (усна) </td> 
									<td>до 10 хвилин</td> 
									<td>200 грн </td> </tr>
								<tr> 
									<td>Підбір видів економічної діяльності за КВЕД </td> 
									<td>1 робочий день</td> 
									<td>200 грн за один напрямок діяльності</td> 
								</tr>
								<tr> 
									<td>Реєстрація платником єдиного податку (1,2,3 групи) або платником ПДВ.</td> 
									<td>від 1 робочого дня до 3-х місяців (залежить від обраної групи оподаткування і податкових періодів)</td> 
									<td> від 800 грн.</td> 
								</tr>
								<tr> 
									<td>Одержання витягу з ЄДРПОУ </td> 
									<td>30 хвилин </td>
									<td>500 грн.</td> 
								</tr>
								<tr> 
									<td>Одержання витягу з реєстру платників ЄП чи ПДВ</td> 
									<td>1-3 робочі дні</td> 
									<td>500 грн. </td> 
								</tr>
								<tr> 
									<td>Реєстрація РРО або ПРРО</td> 
									<td>1-3 робочих днів</td>
									 <td> 1500 грн.</td>
								</tr>
								<tr> 
									<td>Виготовлення печатки</td> 
									<td>1 робочий день</td> 
									<td>600грн.</td> 
								</tr>
								<tr> 
									<td>Допомога в отримані електронного цифрового підпису (ключа) </td> 
									<td>1-2 робочі дні</td> 
									<td>від 200 грн.</td>
								</tr>
								<tr> 
									<td>Бухгалтерський супровід </td> 
									<td>1 місяць</td> 
									<td>від 500 грн.</td>
								</tr>
							</tbody>
							</table>
						
					</React.Fragment>
				</TextBlock>
			</React.Fragment>
    );
  }

	export default H2;


// WEBPACK FOOTER //
// ./src/Page/H2.jsx